(function(){
  if(localStorage.getItem('arissai_popup_seen')) return;
  if(/bot|crawler|spider|HeadlessChrome/i.test(navigator.userAgent)) return;

  var shown = false;
  function show(){
    if(shown) return; shown=true;

    var overlay = document.createElement('div');
    overlay.id = 'arissai-popup-overlay';
    overlay.setAttribute('data-testid','arissai-popup');
    overlay.innerHTML = `
    <div class="ap-bg"></div>
    <div class="ap-box" role="dialog" aria-modal="true" aria-label="10% off your first Arissai order">
      <button class="ap-close" aria-label="Close" data-testid="popup-close">&times;</button>
      <div class="ap-eye">&#9673;</div>
      <div class="ap-kicker">EVERYTHING ON SALE&nbsp;&middot;&nbsp;1ST ORDER PERK</div>
      <h2 class="ap-h">Take an extra<br><span class="ap-pct">10% off</span><br>your first order.</h2>
      <p class="ap-p">Free shipping to US &amp; Canada. Drop your email &mdash; we&rsquo;ll send your code.</p>
      <form id="ap-form" action="/contact#contact_form" method="post" accept-charset="UTF-8" enctype="multipart/form-data" novalidate>
        <input type="hidden" name="form_type" value="customer">
        <input type="hidden" name="utf8" value="&#10003;">
        <input type="hidden" name="contact[tags]" value="newsletter,popup,first-order-10">
        <input type="email" name="contact[email]" required placeholder="your@email.com" autocomplete="email" data-testid="popup-email">
        <button type="submit" data-testid="popup-submit">Reveal My Code</button>
      </form>
      <div id="ap-success" class="ap-success" hidden>
        <div class="ap-code-label">YOUR CODE</div>
        <div class="ap-code" data-testid="popup-code">SOULIST10</div>
        <p class="ap-p ap-p-small">Copied to your clipboard. Use it at checkout &mdash; or just shop, we&rsquo;ll email it too.</p>
        <a class="ap-shop-btn" href="/collections/bestsellers" data-testid="popup-shop">Shop Bestsellers &rarr;</a>
      </div>
      <p class="ap-fine">No spam. Unsubscribe any time.</p>
    </div>`;
    document.body.appendChild(overlay);
    document.body.style.overflow='hidden';

    function close(){
      overlay.remove();
      document.body.style.overflow='';
      localStorage.setItem('arissai_popup_seen','1');
    }
    overlay.querySelector('.ap-close').addEventListener('click', close);
    overlay.querySelector('.ap-bg').addEventListener('click', close);
    document.addEventListener('keydown', function esc(e){
      if(e.key==='Escape'){ close(); document.removeEventListener('keydown', esc); }
    });

    overlay.querySelector('#ap-form').addEventListener('submit', function(e){
      e.preventDefault();
      var emailEl = overlay.querySelector('input[name="contact[email]"]');
      var email = emailEl && emailEl.value;
      if(!email) return;
      localStorage.setItem('arissai_popup_seen','1');
      localStorage.setItem('arissai_first_order_code','SOULIST10');
      try { var fd = new FormData(e.target);
            fetch('/contact#contact_form', { method:'POST', body: fd, mode:'no-cors' });
      } catch(err) {}
      try { navigator.clipboard && navigator.clipboard.writeText('SOULIST10'); } catch(err) {}
      try { if(window.pintrk) pintrk('track','lead',{lead_type:'newsletter'}); } catch(err){}
      try { if(window.fbq) fbq('track','Lead'); } catch(err){}
      overlay.querySelector('#ap-form').setAttribute('hidden','');
      overlay.querySelector('#ap-success').removeAttribute('hidden');
    });
  }

  // Trigger 1: after 18s on page
  var timer = setTimeout(show, 18000);

  // Trigger 2: exit intent (desktop)
  document.addEventListener('mouseout', function(e){
    if(!e.relatedTarget && e.clientY < 10) show();
  });

  // Trigger 3 (mobile): IntersectionObserver on a sentinel placed ~60% down the page.
  // Far cheaper than scroll listener — fires once, never on every frame.
  function setupSentinel(){
    if(!('IntersectionObserver' in window)) return;
    var s = document.createElement('div');
    s.style.cssText = 'position:absolute;pointer-events:none;height:1px;width:1px;left:0;';
    // Defer DOM read until next frame to avoid forced reflow during page init.
    requestAnimationFrame(function(){
      var docH = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
      s.style.top = Math.round(docH * 0.55) + 'px';
      document.body.appendChild(s);
    });
    var io = new IntersectionObserver(function(entries){
      if(entries[0] && entries[0].isIntersecting){
        io.disconnect();
        s.remove();
        show();
      }
    });
    io.observe(s);
  }
  if(document.readyState !== 'loading') setupSentinel();
  else document.addEventListener('DOMContentLoaded', setupSentinel);
})();
